import React, {useState, createContext} from 'react';
import {UserLoginService, SessionService} from "../services";

export const CurrentUserContext = createContext();

export const CurrentUserProvider = props => {
    const [currentUser, setCurrentUser] = useState({});
    const [rights, setRights] = useState([]);

    const isAuthInProgress =
    window.location.pathname.startsWith("/api/oauth2/authorization") ||
    window.location.pathname.startsWith("/api/login/oauth2/code"); 

    const refreshUserContext = () => {
        const key = localStorage.getItem('Roles');
        if(key){
            localStorage.removeItem('Roles')
        }
       
        SessionService.getCookie()
          .then((response) => {
            console.log("SESSION", response);
          })

        if(!isAuthInProgress){
           UserLoginService.getCurrentUser()
            .then((response) => {
                setCurrentUser(response.data);
                console.log("RESPONSE :", response);
                setRights(response.data.authorities.map(a=>a.authority));          
            }).catch((error) => {
            setCurrentUser({})
            setRights([])
            if (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') {

            }else{
              //  window.location = '/api/login'
            }
            if(error.status === 401){
                console.log("status is 401")
                window.location = "/oauth2/authorization/azure";
            }
        });
          }
       
    }

    React.useEffect(() => {
        localStorage.setItem('Roles', rights);
    },[rights])

    React.useEffect(() => {
        refreshUserContext()
    }, []);

    return (
        <CurrentUserContext.Provider value={{currentUser, rights, refreshUserContext}}>
            {props.children}
        </CurrentUserContext.Provider>
    );
}